module.exports = __webpack_public_path__ + "static/media/suite1.7d9a2190.jpg";